import React, {useState} from 'react';
import {Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography} from '@mui/material';
import ApiService from '../network/API';

// Обращение студента к преподавателю (апелляция): несогласие с оценкой, вопрос по проверке, сбой окружения.
// problemId — по какой задаче; без него обращение общее.
const AppealDialog = ({open, onClose, problemId, problemTitle, onSent}) => {
    const [text, setText] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [sent, setSent] = useState(false);

    const close = () => {
        setText('');
        setError(null);
        setSent(false);
        onClose();
    };

    const send = async () => {
        setBusy(true);
        setError(null);
        try {
            await ApiService.createAppeal(problemId, text);
            setSent(true);
            if (onSent) onSent();
        } catch (e) {
            setError(e.reason || e.message || 'Не удалось отправить обращение');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
            <DialogTitle>{problemTitle ? `Обращение по задаче «${problemTitle}»` : 'Обращение к преподавателю'}</DialogTitle>
            <DialogContent>
                {sent ? (
                    <Alert severity="success" sx={{mt: 1}}>
                        Обращение отправлено. Ответ придёт уведомлением, а все обращения видны в разделе «Обращения».
                    </Alert>
                ) : (
                    <>
                        <Typography variant="body2" color="text.secondary" sx={{mb: 2, mt: 0.5}}>
                            Опишите, с чем не согласны или что пошло не так: что вы сделали и какой результат ожидали.
                            Преподаватель примет или отклонит обращение и напишет комментарий.
                        </Typography>
                        {error && <Alert severity="error" sx={{mb: 2}}>{error}</Alert>}
                        <TextField
                            autoFocus multiline minRows={4} maxRows={12} fullWidth
                            label="Текст обращения" value={text} onChange={(e) => setText(e.target.value)}
                            slotProps={{htmlInput: {maxLength: 2000}}}
                            helperText={text.trim().length < 10 ? `Нужно ещё ${10 - text.trim().length} симв. (минимум 10) · ${text.length} / 2000` : `${text.length} / 2000`}
                        />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={close}>{sent ? 'Закрыть' : 'Отмена'}</Button>
                {!sent && <Button variant="contained" onClick={send} disabled={busy || text.trim().length < 10}>Отправить</Button>}
            </DialogActions>
        </Dialog>
    );
};

export default AppealDialog;
